import React from "react";
import { connect } from "react-redux";
import { ReduxState } from "../../../../../store/ReduxState";
import { CreatePartner } from "./CreatePartner";
import { RouteComponentProps } from "react-router";

interface Params {
    partnerId: string;
}

interface StateProps {
    params: Params;
}

type Props = StateProps;

/**
 *
 */
export const mapStateToProps = (s: ReduxState, p: RouteComponentProps): StateProps => ({
    params: p.match.params as Params,
});

/**
 *
 * @param s
 */

/**
 *
 */
export class EditPartnerComp
    extends React.Component<Props, {}> {

    /**
     *
     * @param props
     * @param ctx
     */
    public constructor(props: Props, ctx?: {}) {
        super(props, ctx);
    }

    public render() {
        return (
            <CreatePartner edit partnerId={this.props.params.partnerId} />
        );
    }
}

/**
 *
 */
export const EditPartner = connect(
    mapStateToProps,
    undefined,
)((props: Props) => <EditPartnerComp {...props} />);
